import { AnyAction } from '@reduxjs/toolkit'

import * as actionTypes from './actionTypes'
import { cleanEventTypes, cleanLogEventTypes } from './util'

type SpaceChatbotLogsPageState = {
  qa?: any
  logs?: unknown[]
  hasMore?: boolean
  totalResults?: any
  offset?: number
  eventTypes?: unknown[]
}

const initialState: SpaceChatbotLogsPageState = {}

export default function qaLogsReducer(state = initialState, action: AnyAction): SpaceChatbotLogsPageState {
  switch (action.type) {
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SET_SUCCESS: {
      return {
        ...state,
        qa: action.response
      }
    }
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SET_LOGS_SUCCESS: {
      return {
        ...state,
        logs: cleanLogEventTypes(action.response.results),
        hasMore: action.response.hasMore,
        totalResults: action.response.totalResults,
        offset: action.response.offset
      }
    }
    case actionTypes.FETCH_KNOWLEDGE_QUESTION_SET_EVENT_TYPES_SUCCESS: {
      return {
        ...state,
        eventTypes: cleanEventTypes(action.response)
      }
    }
    default: {
      return state
    }
  }
}
